import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import FestiveSale from "../components/FestiveSale";
import CategoryGrid from "../components/CategoryGrid";
import BestSellers from "../components/BestSellers";
import Lookbook from "../components/Lookbook";
import ScentWall from "../components/ScentWall";

const Home = () => {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <FestiveSale />
        <CategoryGrid />
        <BestSellers />
        <Lookbook />
        <ScentWall />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
